import { render, staticRenderFns } from "./FontSizePicker.vue?vue&type=template&id=5053a4b6"
import script from "./FontSizePicker.vue?vue&type=script&lang=js"
export * from "./FontSizePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports